import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';

export default function NotFound() {
  const { T } = useTheme();
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: '100vh', background: T.bg, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', fontFamily: "'DM Sans',sans-serif", color: T.text }}>
      <p style={{ fontSize: 80, fontWeight: 800, color: T.border, letterSpacing: '-4px', marginBottom: 8, fontFamily: "'DM Mono',monospace" }}>404</p>
      <h1 style={{ fontSize: 24, fontWeight: 700, marginBottom: 8 }}>Page not found</h1>
      <p style={{ color: T.textMuted, fontSize: 14, marginBottom: 32 }}>This page doesn't exist or has been moved.</p>
      <button onClick={() => navigate('/markets')} style={{ background: T.accent, color: '#fff', border: 'none', borderRadius: 8, padding: '12px 24px', fontWeight: 600, cursor: 'pointer', fontSize: 14 }}>
        Back to Markets
      </button>
    </div>
  );
}